module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_null@2x.f3340e60.png";